export const getRoles = () => {
    const roles = localStorage.getItem('roles')
    if (!roles) {
        return null;
    }
    return JSON.parse(roles);
}

export const getPermissions = () => {
    const permissions = localStorage.getItem('permissions')
    if (!permissions) {
        return null;
    }
    return JSON.parse(permissions);
}